module.exports = __webpack_public_path__ + "static/media/MHRM39N0023.4c6e2c49.svg";